<div class="p-3 md:p-4">
  <!-- Header mejorado sin panel -->
  <div class="flex align-items-center justify-content-between mb-4">
    <div class="flex align-items-center">
      <i class="pi pi-list mr-3 text-primary" style="font-size: 1.5rem"></i>
      <div>
        <h1 class="m-0 text-2xl font-bold text-900">Listas de productos</h1>
        <p class="m-0 mt-1 text-color-secondary">
          Gestiona tus listas y productos favoritos
        </p>
      </div>
    </div>
  </div>

  <!-- Loading state mejorado con skeletons -->
  <div *ngIf="showLoading" class="mt-4">
    <!-- Desktop loading -->
    <div class="hidden lg:flex gap-4" style="height: 950px">
      <!-- Panel izquierdo skeleton -->
      <div style="flex: 0 0 33%; min-width: 300px; height: 100%">
        <div class="h-full surface-card border-round-lg overflow-hidden shadow-2 border-1 border-200 flex flex-column">
          <!-- Header skeleton -->
          <div class="p-4 border-bottom-1 surface-border bg-gradient-to-r from-primary-50 to-primary-100">
            <div class="flex align-items-center gap-3">
              <p-skeleton shape="circle" size="3rem"></p-skeleton>
              <div class="flex-grow-1">
                <p-skeleton width="8rem" height="1.5rem" styleClass="mb-2"></p-skeleton>
                <p-skeleton width="6rem" height="1rem"></p-skeleton>
              </div>
            </div>
          </div>

          <!-- Search skeleton -->
          <div class="p-4 surface-100 border-bottom-1 surface-border">
            <p-skeleton width="100%" height="2.5rem" borderRadius="6px"></p-skeleton>
          </div>

          <!-- Lists skeleton -->
          <div style="flex-grow: 1; padding: 1rem">
            <div class="flex flex-column gap-3">
              <div *ngFor="let item of [1, 2, 3, 4, 5]" class="p-3 border-round surface-card">
                <div class="flex align-items-center justify-content-between">
                  <div class="flex-grow-1">
                    <p-skeleton width="10rem" height="1rem" styleClass="mb-2"></p-skeleton>
                    <p-skeleton width="5rem" height="0.8rem"></p-skeleton>
                  </div>
                  <p-skeleton shape="circle" size="2rem"></p-skeleton>
                </div>
              </div>
            </div>
          </div>

          <!-- Footer skeleton -->
          <div class="p-4 border-top-1 surface-border">
            <p-skeleton width="100%" height="2.5rem" borderRadius="6px"></p-skeleton>
          </div>
        </div>
      </div>

      <!-- Panel derecho skeleton -->
      <div style="flex: 1; min-width: 0; height: 100%">
        <div class="h-full surface-card border-round-lg overflow-hidden shadow-2 border-1 border-200 flex flex-column">
          <!-- Header skeleton -->
          <div class="p-4 border-bottom-1 surface-border bg-gradient-to-r from-green-50 to-blue-50">
            <div class="flex align-items-center justify-content-between">
              <div class="flex align-items-center gap-3">
                <p-skeleton shape="circle" size="3rem"></p-skeleton>
                <div>
                  <p-skeleton width="12rem" height="1.5rem" styleClass="mb-2"></p-skeleton>
                  <p-skeleton width="8rem" height="1rem"></p-skeleton>
                </div>
              </div>
              <div class="flex gap-2">
                <p-skeleton shape="circle" size="2rem"></p-skeleton>
                <p-skeleton shape="circle" size="2rem"></p-skeleton>
                <p-skeleton shape="circle" size="2rem"></p-skeleton>
              </div>
            </div>
          </div>

          <!-- Search skeleton -->
          <div class="p-4 surface-100 border-bottom-1 surface-border">
            <p-skeleton width="100%" height="2.5rem" borderRadius="6px"></p-skeleton>
          </div>

          <!-- Selection header skeleton -->
          <div class="px-4 py-3 surface-50 border-bottom-1 surface-border" style="min-height: 70px">
            <div class="flex align-items-center justify-content-between">
              <div class="flex align-items-center gap-3">
                <p-skeleton size="1rem" shape="circle"></p-skeleton>
                <div>
                  <p-skeleton width="12rem" height="1rem" styleClass="mb-1"></p-skeleton>
                  <p-skeleton width="8rem" height="0.8rem"></p-skeleton>
                </div>
              </div>
              <p-skeleton width="4rem" height="1.5rem" borderRadius="4px"></p-skeleton>
            </div>
          </div>

          <!-- Products skeleton -->
          <div style="flex-grow: 1; padding: 1rem">
            <div class="flex flex-column gap-2">
              <div *ngFor="let item of [1, 2, 3, 4, 5, 6, 7, 8]" class="p-3 border-round surface-card">
                <div class="flex align-items-center gap-4">
                  <p-skeleton size="1rem" shape="circle"></p-skeleton>
                  <p-skeleton width="50px" height="50px" borderRadius="6px"></p-skeleton>
                  <div class="flex-grow-1">
                    <p-skeleton width="70%" height="1rem" styleClass="mb-2"></p-skeleton>
                    <p-skeleton width="40%" height="0.8rem"></p-skeleton>
                  </div>
                  <div class="flex gap-2">
                    <p-skeleton shape="circle" size="2rem"></p-skeleton>
                    <p-skeleton shape="circle" size="2rem"></p-skeleton>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Footer skeleton -->
          <div class="p-4 border-top-1 surface-border">
            <p-skeleton width="100%" height="2.5rem" borderRadius="6px"></p-skeleton>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile loading -->
    <div class="block lg:hidden">
      <!-- Lists accordion skeleton -->
      <div class="surface-card border-round-lg p-4 mb-4">
        <div class="flex align-items-center justify-content-between mb-3">
          <p-skeleton width="8rem" height="1.2rem"></p-skeleton>
          <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
        </div>
        <div class="grid gap-3">
          <div *ngFor="let item of [1, 2, 3]" class="col-12">
            <div class="p-3 border-round surface-100">
              <div class="flex align-items-center justify-content-between">
                <div class="flex-grow-1">
                  <p-skeleton width="8rem" height="1rem" styleClass="mb-2"></p-skeleton>
                  <p-skeleton width="5rem" height="0.8rem"></p-skeleton>
                </div>
                <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Products card skeleton -->
      <div class="surface-card border-round-lg p-4" style="height: 600px">
        <!-- Header -->
        <div class="flex align-items-center gap-3 mb-4">
          <p-skeleton shape="circle" size="2.5rem"></p-skeleton>
          <div class="flex-grow-1">
            <p-skeleton width="10rem" height="1.2rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton width="6rem" height="0.8rem"></p-skeleton>
          </div>
        </div>

        <!-- Products list -->
        <div class="flex flex-column gap-3">
          <div *ngFor="let item of [1, 2, 3, 4, 5, 6]"
            class="flex align-items-center gap-3 p-3 surface-100 border-round">
            <p-skeleton size="1rem" shape="circle"></p-skeleton>
            <p-skeleton width="40px" height="40px" borderRadius="4px"></p-skeleton>
            <div class="flex-grow-1">
              <p-skeleton width="80%" height="0.9rem" styleClass="mb-1"></p-skeleton>
              <p-skeleton width="50%" height="0.7rem"></p-skeleton>
            </div>
            <div class="flex gap-1">
              <p-skeleton shape="circle" size="1.8rem"></p-skeleton>
              <p-skeleton shape="circle" size="1.8rem"></p-skeleton>
            </div>
          </div>
        </div>

        <!-- Footer button -->
        <div class="mt-4">
          <p-skeleton width="100%" height="2.5rem" borderRadius="6px"></p-skeleton>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty state más atractivo -->
  <div *ngIf="listas.length === 0 && !showLoading" class="mt-4">
    <p-card styleClass="border-none shadow-2">
      <div class="text-center py-8">
        <div class="mb-4">
          <i class="pi pi-inbox text-6xl text-color-secondary opacity-50"></i>
        </div>
        <h3 class="mt-4 mb-3 text-2xl font-semibold">
          ¡Comienza tu primera lista!
        </h3>
        <p class="text-color-secondary mb-6 max-w-20rem mx-auto">
          Organiza tus productos favoritos creando listas personalizadas para
          diferentes proyectos o necesidades.
        </p>
        <div class="flex flex-column sm:flex-row justify-content-center gap-3">
          <p-button label="Crear Lista" icon="pi pi-upload" (click)="isWishlistModalVisible = true"
            styleClass="p-button-lg">
          </p-button>
        </div>
      </div>
    </p-card>
  </div>

  <!-- Content responsivo con listas -->
  <div *ngIf="listas.length > 0" class="mt-4">
    <!-- Vista móvil MEJORADA -->
    <div class="block lg:hidden">
      <!-- Selector de lista más compacto -->
      <div class="surface-card border-round-lg mb-3 overflow-hidden shadow-2 border-1 border-200 flex flex-column">
        <!-- Header igual al de productos -->
        <div class="p-3 border-bottom-1 surface-border bg-gradient-to-r from-primary-50 to-primary-100">
          <div class="flex align-items-center justify-content-between">
            <div class="flex align-items-center">
              <div>
                <h3 class="m-0 text-lg font-semibold text-900">
                  Seleccionar lista
                </h3>
                <div class="flex align-items-center gap-2 text-sm text-600 mt-1">
                  <span>{{ listas_filtered.length || 0 }} listas
                    disponibles</span>
                  <span>•</span>
                  <span>{{ indexSelectedWishlist + 1 }}/{{
                    listas_filtered.length || 0
                    }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Lista horizontal scrolleable -->
        <div class="p-3 pr-0">
          <div class="flex gap-3 overflow-x-auto pb-2 pr-3" [ngStyle]="{
              'scrollbar-width': 'none',
              '-ms-overflow-style': 'none'
            }">
            <div *ngFor="let lista of listas_filtered; let i = index" class="flex-shrink-0 cursor-pointer"
              (click)="indexSelectedWishlist = i" [ngStyle]="{ 'min-width': '200px' }">
              <div class="p-3 border-round border-1 transition-all transition-duration-200"
                [class.bg-primary]="i === indexSelectedWishlist" [class.text-white]="i === indexSelectedWishlist"
                [class.border-primary]="i === indexSelectedWishlist" [class.surface-100]="i !== indexSelectedWishlist"
                [class.border-200]="i !== indexSelectedWishlist">
                <div class="flex align-items-center justify-content-between mb-1">
                  <p class="m-0 font-semibold text-sm" [class.text-white]="i === indexSelectedWishlist"
                    [class.text-900]="i !== indexSelectedWishlist">
                    {{ lista?.name || '' }}
                  </p>
                  <i *ngIf="lista?.default" class="pi pi-star-fill text-xs"
                    [class.text-yellow-200]="i === indexSelectedWishlist"
                    [class.text-yellow-500]="i !== indexSelectedWishlist"></i>
                </div>
                <div class="flex align-items-center justify-content-between">
                  <span class="text-xs" [class.text-primary-100]="i === indexSelectedWishlist"
                    [class.text-600]="i !== indexSelectedWishlist">
                    {{ lista?.articles?.length || 0 }} productos
                  </span>
                  <p-menu #menu [model]="getMenuItems(lista)" [popup]="true" appendTo="body"></p-menu>
                  <button class="p-1 border-round border-1 flex align-items-center justify-content-center"
                    [class.bg-primary-700]="i === indexSelectedWishlist"
                    [class.border-primary-700]="i === indexSelectedWishlist"
                    [class.text-white]="i === indexSelectedWishlist"
                    [class.bg-surface-100]="i !== indexSelectedWishlist"
                    [class.border-surface-200]="i !== indexSelectedWishlist"
                    [class.text-600]="i !== indexSelectedWishlist" [ngStyle]="{ width: '20px', height: '20px' }"
                    type="button" (click)="menu.toggle($event); $event.stopPropagation()">
                    <i class="pi pi-ellipsis-v" [ngStyle]="{ 'font-size': '8px' }"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Panel de productos optimizado para móvil -->
      <div class="surface-card border-round-lg overflow-hidden shadow-2 border-1 border-200"
        [ngStyle]="{ height: 'calc(100vh - 220px)', 'min-height': '500px' }">
        <!-- Header compacto -->
        <div class="p-3 border-bottom-1 surface-border bg-gradient-to-r from-green-50 to-blue-50">
          <div class="flex align-items-center justify-content-between">
            <div class="flex align-items-center gap-2">
              <!-- <i class="pi pi-box text-primary text-xl"></i> -->
              <div>
                <h3 class="m-0 text-lg font-semibold text-900">
                  {{ listas[indexSelectedWishlist].name || 'Productos' }}
                </h3>
                <div class="flex align-items-center gap-2 text-sm text-600 mt-1">
                  <span>{{
                    currentSelectedList?.articles?.length || 0
                    }}
                    productos</span>
                </div>
              </div>
            </div>
            <!-- Botones de acción compactos -->
            <div class="flex gap-1">
              <p-button icon="pi pi-plus" styleClass="p-button-rounded p-button-sm p-button-text"
                pTooltip="Agregar productos" (click)="addProductsToWishlist()"></p-button>
              <p-button icon="pi pi-upload" styleClass="p-button-rounded p-button-sm p-button-text"
                pTooltip="Carga masiva" [disabled]="!currentSelectedList"
                (click)="addProductsFromFileToWishlist()"></p-button>
            </div>
          </div>
        </div>

        <!-- Búsqueda compacta -->
        <div class="p-3 surface-100 border-bottom-1 surface-border">
          <input pInputText type="text" placeholder="Buscar en esta lista..." class="w-full text-sm"
            [ngStyle]="{ padding: '0.5rem 0.75rem' }" (keyup)="searchProductOnList($event, indexSelectedWishlist)" />
        </div>

        <!-- Header de selección compacto -->
        <div *ngIf="
            currentSelectedList?.articles?.length &&
            (currentSelectedList?.articles?.length || 0) > 0
          " class="px-3 py-2 surface-50 border-bottom-1 surface-border">
          <div class="flex align-items-center justify-content-between">
            <div class="flex align-items-center gap-2">
              <p-checkbox [(ngModel)]="selectAllProducts" [binary]="true" (onChange)="toggleSelectAll()"></p-checkbox>
              <span class="text-sm font-medium text-900">
                Seleccionar todos ({{ getSelectedProductsCount() }}/{{
                currentSelectedList?.articles?.length || 0
                }})
              </span>
            </div>
            <p-button *ngIf="getSelectedProductsCount() > 0" label="Limpiar" icon="pi pi-times"
              styleClass="p-button-text p-button-sm" size="small" (click)="clearSelection()"></p-button>
          </div>
        </div>

        <!-- Lista de productos con scroll optimizado -->
        <div [ngStyle]="{
            'flex-grow': '1',
            height: 'calc(100% - 180px)',
            'overflow-y': 'auto'
          }">
          <!-- Productos -->
          <div *ngIf="
              currentSelectedList?.articles?.length &&
              (currentSelectedList?.articles?.length || 0) > 0
            ">
            <div *ngFor="
                let product of currentSelectedList?.articles;
                let i = index;
                let isLast = last
              " class="px-4 py-3 transition-all transition-duration-150 cursor-pointer border-bottom-1 surface-border"
              [class.border-bottom-none]="isLast" [class.bg-primary-50]="selectedProducts.has(product.sku)">
              <div class="flex align-items-center gap-4 w-full">
                <!-- Checkbox de selección -->
                <div class="flex-shrink-0">
                  <p-checkbox [ngModel]="isProductSelected(product)" [binary]="true"
                    (ngModelChange)="onProductSelectionChange(product, $event)"></p-checkbox>
                </div>

                <!-- Imagen del producto pequeña -->
                <div class="flex-shrink-0">
                  <a [routerLink]="
                      rootService.product(product.sku, product.name)
                    ">
                    <img [src]="product.preview" [alt]="product.name"
                      class="border-round hover:scale-105 transition-all transition-duration-200 border-1 border-300"
                      [ngStyle]="{
                        width: '50px',
                        height: '50px',
                        'object-fit': 'cover'
                      }" />
                  </a>
                </div>

                <!-- Información del producto - ocupa todo el espacio disponible -->
                <div class="flex-grow-1 min-w-0">
                  <p class="m-0 font-medium text-sm line-height-3 text-900" [ngStyle]="{
                      display: '-webkit-box',
                      '-webkit-line-clamp': '2',
                      '-webkit-box-orient': 'vertical',
                      overflow: 'hidden',
                      'text-overflow': 'ellipsis'
                    }">
                    {{ product.name | titlecase }}
                  </p>
                  <p class="m-0 mt-1 product-sku text-color-secondary">
                    {{ product.sku }}
                  </p>
                </div>

                <!-- Acciones -->
                <div class="flex gap-2 flex-shrink-0">
                  <p-button icon="pi pi-shopping-cart" pTooltip="Agregar al carro" tooltipPosition="left"
                    styleClass="p-button-rounded p-button-success p-button-sm" size="small"
                    (click)="addtoCart(product); $event.stopPropagation()">
                  </p-button>
                  <p-button icon="pi pi-trash" severity="danger" pTooltip="Quitar de la lista" tooltipPosition="left"
                    styleClass="p-button-rounded p-button-sm" size="small" (click)="
                      deleteProductFromWishlist(
                        currentSelectedList,
                        product.sku
                      );
                      $event.stopPropagation()
                    ">
                  </p-button>
                </div>
              </div>
            </div>
          </div>

          <!-- Empty state simplificado -->
          <div *ngIf="!currentSelectedList?.articles?.length"
            class="flex flex-column align-items-center justify-content-center text-center px-4 py-8"
            [ngStyle]="{ 'min-height': '400px' }">
            <!-- Icono simple -->
            <div class="mb-4">
              <i class="pi pi-inbox text-6xl text-400 opacity-60"></i>
            </div>

            <!-- Texto simple -->
            <h3 class="text-xl font-semibold text-900 mb-2">
              Sin productos en esta lista
            </h3>
            <p class="text-600 text-sm mb-4 px-2">
              Agrega productos a
              <strong>"{{ currentSelectedList?.name || listas[indexSelectedWishlist].name || 'esta lista'









                }}"</strong>
            </p>
          </div>
        </div>

        <!-- Footer mejorado -->
        <div class="p-4 bg-white border-top-1 surface-border flex-shrink-0">
          <p-button [label]="
              getSelectedProductsCount() > 0
                ? 'Agregar seleccionados al carrito (' +
                  getSelectedProductsCount() +
                  ')'
                : 'Agregar al carro'
            " icon="pi pi-shopping-cart" iconPos="right" styleClass="w-full font-medium" [disabled]="
              getSelectedProductsCount() === 0 && selectAllProducts === false
            " (click)="addSelectedToCart()">
          </p-button>
        </div>
      </div>
    </div>

    <!-- Vista desktop con flexbox normal -->
    <div class="hidden lg:flex gap-4" [ngStyle]="{ height: '950px' }">
      <!-- Panel izquierdo (33%) - ORIGINAL -->
      <div [ngStyle]="{ flex: '0 0 33%', 'min-width': '300px', height: '100%' }">
        <div class="h-full surface-card border-round-lg overflow-hidden shadow-2 border-1 border-200 flex flex-column">
          <!-- Header ORIGINAL -->
          <div class="p-4 border-bottom-1 surface-border bg-gradient-to-r from-primary-50 to-primary-100 flex-shrink-0">
            <div class="flex align-items-center gap-3">
              <div class="w-3rem h-3rem border-round flex align-items-center justify-content-center shadow-2" [ngStyle]="{
                  background: 'linear-gradient(135deg, #3b82f6, #1e40af)'
                }">
                <i class="pi pi-list text-white text-xl"></i>
              </div>
              <div>
                <h2 class="m-0 font-bold text-xl text-900">Mis listas</h2>
                <div class="flex align-items-center">
                  <p class="m-0 text-sm text-600 font-medium">
                    {{ listas_filtered.length || 0 }}
                    {{
                    (listas_filtered.length || 0) === 1 ? 'lista' : 'listas'
                    }}
                    <span *ngIf="listSearchQuery">
                      de {{ listas.length || 0 }} total{{
                      (listas.length || 0) === 1 ? '' : 'es'
                      }}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- Búsqueda ORIGINAL -->
          <div class="p-4 surface-100 border-bottom-1 surface-border">
            <div class="flex flex-column gap-3">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon bg-primary text-white">
                  <i class="pi pi-search"></i>
                </span>
                <input pInputText type="text" placeholder="Filtrar listas..." class="w-full"
                  [(ngModel)]="listSearchQuery" (keyup)="filterLists($event)" />
              </div>
            </div>
          </div>

          <!-- Lista de listas ORIGINAL - con bordes de separación -->
          <div [ngStyle]="{
              'flex-grow': '1',
              position: 'relative',
              'min-height': '0'
            }">
            <p-scrollPanel [style]="{ width: '100%', height: '100%' }" styleClass="surface-card">
              <div>
                <!-- Mostrar mensaje cuando no hay resultados de búsqueda -->
                <div *ngIf="
                    (listas_filtered?.length || 0) === 0 && listSearchQuery
                  " class="text-center p-4">
                  <i class="pi pi-search text-3xl text-400 mb-3"></i>
                  <p class="text-600 m-0">
                    No se encontraron listas que coincidan con "{{
                    listSearchQuery
                    }}"
                  </p>
                  <p-button label="Limpiar búsqueda" styleClass="p-button-text p-button-sm mt-2"
                    (click)="clearListFilter()"></p-button>
                </div>

                <!-- Lista de listas filtradas -->
                <ng-container *ngFor="
                    let lista of listas_filtered;
                    let i = index;
                    let isLast = last
                  ">
                  <div class="p-3 transition-all transition-duration-200 cursor-pointer border-bottom-1 surface-border"
                    [class.border-bottom-none]="isLast" [class.bg-primary]="i === indexSelectedWishlist"
                    [class.text-white]="i === indexSelectedWishlist" [class.bg-gray-50]="i !== indexSelectedWishlist"
                    [class.hover:bg-gray-100]="i !== indexSelectedWishlist" (click)="indexSelectedWishlist = i">
                    <div class="flex align-items-center justify-content-between w-full">
                      <!-- Información de la lista SIN iconos ni extras -->
                      <div class="flex-grow-1 min-w-0">
                        <div class="flex align-items-center mb-1">
                          <p class="m-0 font-bold text-sm line-height-3 flex-grow-1"
                            [class.text-white]="i === indexSelectedWishlist"
                            [class.text-900]="i !== indexSelectedWishlist" [ngStyle]="{
                              display: '-webkit-box',
                              '-webkit-line-clamp': '2',
                              '-webkit-box-orient': 'vertical',
                              overflow: 'hidden',
                              'text-overflow': 'ellipsis'
                            }">
                            {{ lista?.name || '' }}
                          </p>
                        </div>

                        <!-- Solo contador de productos -->
                        <div class="flex align-items-center gap-1">
                          <!-- Tag principal con fondo verde -->
                          <span
                            class="surface-200 text-600 text-xs px-2 py-1 border-round font-medium flex align-items-center">
                            {{ lista?.articles?.length || 0 }} productos
                          </span>
                          <span *ngIf="lista?.default"
                            class="bg-green-500 text-white text-xs px-2 py-1 border-round font-medium flex align-items-center">
                            Principal
                          </span>
                        </div>
                      </div>

                      <!-- Menú de acciones ORIGINAL como en la imagen -->
                      <div class="flex-shrink-0 ml-2">
                        <p-menu #menu [model]="getMenuItems(lista)" [popup]="true" appendTo="body"></p-menu>
                        <button
                          class="w-2rem h-2rem border-1 border-round transition-all transition-duration-200 flex align-items-center justify-content-center"
                          [class.bg-primary-700]="i === indexSelectedWishlist" [class.border-primary-700]="
                            i === indexSelectedWishlist
                          " [class.text-white]="i === indexSelectedWishlist"
                          [class.bg-gray-200]="i !== indexSelectedWishlist"
                          [class.border-gray-300]="i !== indexSelectedWishlist"
                          [class.text-gray-600]="i !== indexSelectedWishlist" type="button" (click)="
                            menu.toggle($event); $event.stopPropagation()
                          ">
                          <i class="pi pi-ellipsis-v text-xs" [class.text-white]="i === indexSelectedWishlist"
                            [class.text-gray-600]="i !== indexSelectedWishlist"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </p-scrollPanel>
          </div>

          <!-- Footer ORIGINAL -->
          <div class="p-4 bg-white border-top-1 surface-border flex-shrink-0">
            <p-button label="Nueva lista" icon="pi pi-plus" styleClass="w-full font-medium"
              (click)="isWishlistModalVisible = true">
            </p-button>
          </div>
        </div>
      </div>

      <!-- Panel derecho (67%) - ORIGINAL -->
      <div [ngStyle]="{ flex: '1', 'min-width': '0', height: '100%' }">
        <div class="h-full surface-card border-round-lg overflow-hidden shadow-2 border-1 border-200 flex flex-column">
          <!-- Header del panel de productos ORIGINAL -->
          <div class="p-4 border-bottom-1 surface-border bg-gradient-to-r from-green-50 to-blue-50 flex-shrink-0">
            <div class="flex align-items-center justify-content-between">
              <div class="flex align-items-center gap-3">
                <div class="w-3rem h-3rem border-round flex align-items-center justify-content-center shadow-2"
                  [ngStyle]="{
                    background: 'linear-gradient(135deg, #10b981, #3b82f6)'
                  }">
                  <i class="pi pi-box text-white text-xl"></i>
                </div>
                <div>
                  <h2 class="m-0 font-bold text-xl text-900">
                    {{ currentSelectedList?.name || 'Productos' }}
                  </h2>
                  <div class="flex align-items-center text-sm text-600">
                    <div class="flex align-items-center">
                      <span>
                        {{ currentSelectedList?.articles?.length || 0 }}
                        {{
                        (currentSelectedList?.articles?.length || 0) === 1
                        ? 'producto'
                        : 'productos'
                        }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Acciones ORIGINAL -->
              <div class="hidden md:flex align-items-center gap-2">
                <p-button icon="pi pi-plus" styleClass="p-button-rounded p-button-sm" severity="success"
                  pTooltip="Agregar productos" tooltipPosition="bottom" (click)="addProductsToWishlist()">
                </p-button>
                <p-button icon="pi pi-upload" styleClass="p-button-rounded p-button-sm" severity="info"
                  pTooltip="Carga masiva" tooltipPosition="bottom" [disabled]="!currentSelectedList"
                  (click)="addProductsFromFileToWishlist()">
                </p-button>
                <!--<p-button
                  icon="pi pi-download"
                  styleClass="p-button-rounded p-button-sm"
                  severity="help"
                  pTooltip="Exportar lista"
                  tooltipPosition="bottom"
                  [disabled]="!listas[indexSelectedWishlist]"
                >
                </p-button> -->
              </div>
            </div>
          </div>

          <!-- Búsqueda ORIGINAL -->
          <div class="p-4 surface-100 border-bottom-1 surface-border">
            <div class="flex flex-column gap-3">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon bg-primary text-white">
                  <i class="pi pi-search"></i>
                </span>
                <input pInputText type="text" placeholder="Buscar productos en esta lista..." class="w-full"
                  (keyup)="searchProductOnList($event, indexSelectedWishlist)" />
              </div>
            </div>
          </div>
          <!-- Header de selección -->
          <div *ngIf="
              currentSelectedList?.articles?.length &&
              (currentSelectedList?.articles?.length || 0) > 0
            "
            class="flex align-items-center justify-content-between px-4 py-3 surface-50 border-bottom-1 surface-border"
            [ngStyle]="{ 'min-height': '70px', height: '70px' }">
            <div class="flex align-items-center gap-3">
              <p-checkbox [(ngModel)]="selectAllProducts" [binary]="true" (onChange)="toggleSelectAll()"></p-checkbox>
              <div class="flex flex-column">
                <span class="text-sm font-semibold text-900">
                  Seleccionar todos los productos
                </span>
                <span class="text-xs text-600 mt-1">
                  {{ getSelectedProductsCount() }} de
                  {{ currentSelectedList?.articles?.length || 0 }}
                  seleccionados
                </span>
              </div>
            </div>
            <div class="flex align-items-center gap-2">
              <p-button variant="text" *ngIf="getSelectedProductsCount() > 0" label="Limpiar" icon="pi pi-times"
                styleClass="p-button-text p-button-sm" size="small" (click)="clearSelection()">
              </p-button>
            </div>
          </div>
          <!-- Panel derecho - CON scroll para los productos -->
          <div [ngStyle]="{
              'flex-grow': '1',
              position: 'relative',
              'min-height': '0'
            }">
            <p-scrollPanel [style]="{ width: '100%', height: '100%' }" styleClass="surface-card">
              <!-- Lista de productos -->
              <div *ngIf="
                  currentSelectedList?.articles?.length &&
                  (currentSelectedList?.articles?.length || 0) > 0
                ">
                <div *ngFor="
                    let product of currentSelectedList?.articles;
                    let i = index;
                    let isLast = last
                  "
                  class="px-4 py-3 transition-all transition-duration-150 cursor-pointer border-bottom-1 surface-border"
                  [class.border-bottom-none]="isLast" [class.bg-primary-50]="selectedProducts.has(product.sku)">
                  <div class="flex align-items-center gap-4 w-full">
                    <!-- Checkbox de selección -->
                    <div class="flex-shrink-0">
                      <p-checkbox [ngModel]="isProductSelected(product)" [binary]="true" (ngModelChange)="
                          onProductSelectionChange(product, $event)
                        "></p-checkbox>
                    </div>

                    <!-- Imagen del producto pequeña -->
                    <div class="flex-shrink-0">
                      <a [routerLink]="
                          rootService.product(product.sku, product.name)
                        ">
                        <img [src]="product.preview" [alt]="product.name"
                          class="border-round hover:scale-105 transition-all transition-duration-200 border-1 border-300"
                          [ngStyle]="{
                            width: '50px',
                            height: '50px',
                            'object-fit': 'cover'
                          }" />
                      </a>
                    </div>

                    <!-- Información del producto - ocupa todo el espacio disponible -->
                    <div class="flex-grow-1 min-w-0">
                      <p class="m-0 font-medium text-sm line-height-3 text-900" [ngStyle]="{
                          display: '-webkit-box',
                          '-webkit-line-clamp': '2',
                          '-webkit-box-orient': 'vertical',
                          overflow: 'hidden',
                          'text-overflow': 'ellipsis'
                        }">
                        {{ product.name | titlecase }}
                      </p>
                      <p class="m-0 mt-1 product-sku text-color-secondary">
                        {{ product.sku }}
                      </p>
                    </div>

                    <!-- Acciones -->
                    <div class="flex gap-2 flex-shrink-0">
                      <p-button icon="pi pi-shopping-cart" pTooltip="Agregar al carro" tooltipPosition="left"
                        styleClass="p-button-rounded p-button-success p-button-sm" size="small"
                        (click)="addtoCart(product); $event.stopPropagation()">
                      </p-button>
                      <p-button icon="pi pi-trash" severity="danger" pTooltip="Quitar de la lista"
                        tooltipPosition="left" styleClass="p-button-rounded p-button-sm" size="small" (click)="
                          deleteProductFromWishlist(
                            currentSelectedList,
                            product.sku
                          );
                          $event.stopPropagation()
                        ">
                      </p-button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Empty state simplificado -->
              <div *ngIf="!currentSelectedList?.articles?.length"
                class="flex flex-column align-items-center justify-content-center text-center px-4 py-8"
                [ngStyle]="{ 'min-height': '400px' }">
                <!-- Icono simple -->
                <div class="mb-4">
                  <i class="pi pi-inbox text-6xl text-400 opacity-60"></i>
                </div>

                <!-- Texto simple -->
                <h3 class="text-xl font-semibold text-900 mb-2">
                  Sin productos en esta lista
                </h3>
                <p class="text-600 mb-4 text-sm max-w-20rem">
                  Usa los botones de arriba para agregar productos a
                  <span class="font-semibold text-primary">"{{ currentSelectedList?.name }}"</span>
                </p>
              </div>
            </p-scrollPanel>
          </div>

          <!-- Footer fijo optimizado -->
          <div *ngIf="
              currentSelectedList?.articles?.length &&
              (currentSelectedList?.articles?.length || 0) > 0
            " class="p-3 bg-white border-top-1 surface-border">
            <p-button [label]="
                getSelectedProductsCount() > 0
                  ? 'Agregar ' + getSelectedProductsCount() + ' al carrito'
                  : 'Agregar al carro'
              " icon="pi pi-shopping-cart" styleClass="w-full font-medium" size="small" [disabled]="
                getSelectedProductsCount() === 0 && selectAllProducts === false
              " (click)="addSelectedToCart()"></p-button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <p-dialog header="Nueva lista" [modal]="true" [(visible)]="isWishlistModalVisible" [style]="{ width: '25rem' }">
    <div class="flex flex-column gap-1 mb-4">
      <label for="wishlistName" class="font-semibold w-24">Nombre</label>
      <input pInputText id="wishlistName" class="flex-auto" autocomplete="off" [(ngModel)]="newWishlistName"
        placeholder="Ingresa el nombre de la lista" maxlength="100" />
    </div>
    <div class="flex gap-2" style="justify-content: end">
      <p-button label="Cancelar" severity="secondary" (click)="isWishlistModalVisible = false; newWishlistName = ''" />
      <p-button label="Guardar" (click)="createWishlist()" [disabled]="!newWishlistName.trim()" />
    </div>
  </p-dialog>
</div>